import { Component } from '@angular/core';
import {
  ECOLAB_LOGO,
  RETURN_TO_ECOLAB,
} from '../../core/constants/app.constants';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-unauthorized',
  imports: [MatToolbarModule],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent {
  ecolabLogo = ECOLAB_LOGO;
  return_to_ecolab = RETURN_TO_ECOLAB;
}
